export default __webpack_public_path__ + "static/media/Walker's Gloves of the Tribes.3d3c2b45.jpg";